import { useState, useEffect } from "react";
import { supabase, BRAND, LINE, MUTED, text, card, btn, textareaStyle, errorText, SHADOW_MODAL, SCRIM, WHITE } from "./constants";
import { CloseButton } from "./shared";
import { useIsMobile } from "./lib/responsive";

// "Send feedback" (20/10): una caja de texto y Enviar. GEMELO de
// components/FeedbackModal.jsx del portal. Lo manda /api/feedback, que lo
// guarda, avisa en Notificaciones y escribe a hello@rutment.com. `page` dice
// desde qué pantalla se envió, para no tener que preguntarlo.

const MAX = 3000;

export default function FeedbackModal({ lang = "en", page = "", onClose }) {
  const es = lang === "es";
  const isMobile = useIsMobile();
  const [msg, setMsg] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const send = async () => {
    if (!msg.trim() || sending) return;
    setSending(true); setErr("");
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const r = await fetch("/api/feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${session?.access_token || ""}` },
        body: JSON.stringify({ message: msg.trim(), page, lang }),
      });
      const data = await r.json().catch(() => ({}));
      if (r.status === 429) setErr(es ? "Has enviado muchos comentarios hoy. Vuelve a intentarlo mañana." : "You've sent a lot of feedback today. Please try again tomorrow.");
      else if (!r.ok || !data.ok) setErr(es ? "No se pudo enviar. Vuelve a intentarlo." : "Couldn't send it. Please try again.");
      else setSent(true);
    } catch (e) {
      setErr(es ? "No se pudo enviar. Vuelve a intentarlo." : "Couldn't send it. Please try again.");
    }
    setSending(false);
  };

  const ready = msg.trim().length > 0 && !sending;
  const body = sent ? (
    <div>
      <div style={{ ...text.cardTitle, marginBottom: 6 }}>{es ? "Gracias" : "Thank you"}</div>
      <p style={{ ...text.body, margin: "0 0 18px" }}>{es ? "Lo leemos todo. Si hace falta, te escribimos." : "We read everything. If needed, we'll get back to you."}</p>
      <button onClick={onClose} style={{ ...btn.primary, ...(isMobile ? { width: "100%", minHeight: 48 } : null) }}>{es ? "Cerrar" : "Close"}</button>
    </div>
  ) : (
    <div>
      <p style={{ ...text.body, margin: "0 0 12px" }}>{es ? "¿Qué mejorarías o qué no funciona? Lo leemos todo." : "What would you improve, or what isn't working? We read everything."}</p>
      <textarea autoFocus value={msg} onChange={e => setMsg(e.target.value.slice(0, MAX))} rows={6} maxLength={MAX}
        placeholder={es ? "Escribe aquí tu comentario…" : "Write your feedback here…"}
        onFocus={e => { e.target.style.borderColor = BRAND; }} onBlur={e => { e.target.style.borderColor = LINE; }}
        style={{ ...textareaStyle, width: "100%", boxSizing: "border-box", resize: "vertical", ...(isMobile ? { fontSize: 16 } : null) }} />
      <div style={{ fontSize: 11, color: MUTED, textAlign: "right", marginTop: 4, fontVariantNumeric: "tabular-nums" }}>{msg.length} / {MAX}</div>
      {err && <div style={{ ...errorText, marginTop: 8 }}>{err}</div>}
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 14 }}>
        <button onClick={onClose} style={{ ...btn.ghost, color: MUTED, ...(isMobile ? { flex: 1, minHeight: 48 } : null) }}>{es ? "Cancelar" : "Cancel"}</button>
        <button onClick={send} disabled={!ready} style={{ ...(ready ? btn.primary : btn.disabled), ...(isMobile ? { flex: 2, minHeight: 48 } : null) }}>
          {sending ? (es ? "Enviando…" : "Sending…") : (es ? "Enviar" : "Send")}
        </button>
      </div>
    </div>
  );

  const title = es ? "Enviar comentarios" : "Send feedback";
  if (isMobile) return (
    <div role="dialog" aria-modal="true" aria-label={title}
      style={{ position: "fixed", inset: 0, zIndex: 3000, background: WHITE, display: "flex", flexDirection: "column", paddingTop: "env(safe-area-inset-top)", boxSizing: "border-box" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, padding: "6px 8px 6px 16px", borderBottom: `1px solid ${LINE}`, minHeight: 56, boxSizing: "border-box" }}>
        <span style={text.cardTitle}>{title}</span>
        <CloseButton onClick={onClose} label={es ? "Cerrar" : "Close"} />
      </div>
      <div style={{ padding: 16, overflowY: "auto" }}>{body}</div>
    </div>
  );
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 3000, background: SCRIM, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div role="dialog" aria-modal="true" aria-label={title} onClick={e => e.stopPropagation()}
        style={{ ...card, width: "min(460px, 100%)", boxSizing: "border-box", boxShadow: SHADOW_MODAL }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 8 }}>
          <span style={text.cardTitle}>{title}</span>
          <CloseButton onClick={onClose} label={es ? "Cerrar" : "Close"} />
        </div>
        {body}
      </div>
    </div>
  );
}
